import { useEffect, useState } from 'react';

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  const scrollToNext = () => {
    const aboutSection = document.getElementById('about');
    aboutSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Premium gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, #0a1628 0%, #0f2747 40%, #132d4a 70%, #0f2747 100%)'
        }}
      />

      {/* Animated ambient light */}
      <div
        className="absolute inset-0 pointer-events-none animate-ambient-breathe"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% 40%, rgba(214, 184, 146, 0.04) 0%, transparent 60%)'
        }}
      />

      {/* Vignette effect */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgba(10, 22, 40, 0.4) 100%)'
        }}
      />

      {/* Main content */}
      <div className="relative z-10 text-center px-8">

        {/* MAVI - Elegant script (Alex Brush) */}
        <h1
          className={`mb-1 transition-all duration-[1400ms] ease-out ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
          style={{
            fontFamily: "'Alex Brush', cursive",
            fontSize: 'clamp(4.5rem, 16vw, 9rem)',
            color: '#d6b892',
            fontWeight: 400,
            letterSpacing: '0.02em',
            lineHeight: 0.9
          }}
        >
          Mavi
        </h1>

        {/* PATISSERIE - elegant serif complement */}
        <h2
          className={`mb-10 transition-all duration-[1400ms] ease-out delay-200 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(1.1rem, 3vw, 1.6rem)',
            color: 'rgba(214, 184, 146, 0.75)',
            fontWeight: 400,
            letterSpacing: '0.4em',
            textTransform: 'uppercase'
          }}
        >
          Patısserıe
        </h2>

        {/* Minimal line */}
        <div
          className={`flex justify-center mb-10 transition-all duration-[1400ms] ease-out delay-300 ${
            isLoaded ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
        >
          <div className="w-12 h-px" style={{ backgroundColor: 'rgba(212, 175, 55, 0.5)' }} />
        </div>

        {/* Tagline */}
        <p
          className={`mb-14 transition-all duration-[1400ms] ease-out delay-400 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)',
            color: 'rgba(184, 197, 214, 0.6)',
            fontWeight: 300,
            letterSpacing: '0.15em'
          }}
        >
          El Yapımı Lezzetler, Unutulmaz Anlar
        </p>

        {/* CTA Button */}
        <div
          className={`transition-all duration-[1400ms] ease-out delay-500 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <button
            onClick={scrollToNext}
            className="group relative px-10 py-3.5 cursor-pointer transition-all duration-500 hover:bg-[rgba(214,184,146,0.06)]"
            style={{
              border: '1px solid rgba(212, 175, 55, 0.35)',
              backgroundColor: 'transparent'
            }}
          >
            <span
              className="transition-all duration-400 group-hover:tracking-[0.3em]"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '0.65rem',
                color: '#d6b892',
                fontWeight: 400,
                letterSpacing: '0.25em',
                textTransform: 'uppercase'
              }}
            >
              Keşfetmeye Başlayın
            </span>
          </button>
        </div>
      </div>

      {/* Scroll indicator - line style */}
      <div
        className={`absolute bottom-10 left-1/2 transform -translate-x-1/2 transition-all duration-[1400ms] ease-out delay-700 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <button
          onClick={scrollToNext}
          className="cursor-pointer"
          aria-label="Scroll down"
        >
          <div
            className="w-px h-14 relative overflow-hidden"
            style={{ backgroundColor: 'rgba(214, 184, 146, 0.2)' }}
          >
            <div
              className="absolute top-0 left-0 w-full h-5 animate-scroll-line"
              style={{ backgroundColor: 'rgba(214, 184, 146, 0.6)' }}
            />
          </div>
        </button>
      </div>
    </section>
  );
}
